unit ImportList;

interface

uses
  System.SysUtils,
  System.Classes,
  JS,
  Web,
  WEBLib.Graphics,
  WEBLib.Controls,
  WEBLib.Forms,
  WEBLib.Dialogs,
  BaseList,
  WEBLib.ExtCtrls,
  WEBLib.Actions,
  Data.DB,
  WEBLib.DB,
  XData.Web.JsonDataset,
  XData.Web.Dataset,
  WEBLib.Grids,
  WEBLib.DBCtrls,
  Vcl.Controls,
  WEBLib.Lists,
  Vcl.StdCtrls,
  WEBLib.StdCtrls,
  smx.webcore.types, WEBLib.WebCtrls;

type
  TImportListForm = class(TBaseListForm)
    ImportDialog: TMessageDlg;
    RefreshTimer: TTimer;
    MainDatasetId: TIntegerField;
    MainDatasetDateAdded: TDateTimeField;
    MainDatasetAddedBy: TIntegerField;
    MainDatasetLastUpdatedBy: TIntegerField;
    MainDatasetLastUpdated: TDateTimeField;
    MainDatasetBatchResolution: TStringField;
    MainDatasetBatchState: TStringField;
    MainDatasetRecordsImported: TIntegerField;
    MainDatasetValidRecords: TIntegerField;
    MainDatasetErrorRecords: TIntegerField;
    MainDatasetMatched: TIntegerField;
    MainDatasetMerged: TIntegerField;
    MainDatasetSourceType: TStringField;
    ImportCount: TTimer;
    MainDatasetSourceDescription: TStringField;
    MainDatasetSourceFile: TStringField;
    MainDatasetGiftAidTotal: TFloatField;
    MainDatasetAmountTotal: TFloatField;
    CloseThisButton: TButton;
    TableBottom: THTMLDiv;
    TableTop: THTMLDiv;
    navigator: THTMLDiv;
    navcol4: THTMLDiv;
    MainDatasetGiftAidTotalStr: TStringField;
    MainDatasetAmountTotalStr: TStringField;
    procedure WebFormDestroy(Sender: TObject);
    procedure AddButtonClick(Sender: TObject);
    procedure DataTableGetCellChildren(Sender: TObject; ACol, ARow: Integer;
        AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure ImportCountTimer(Sender: TObject);
    procedure MainDatasetAfterApplyUpdates(Sender: TDataSet; Info: TResolveResults);
    procedure MainDatasetAfterOpen(Dataset: TDataSet);
    procedure MainDatasetAfterPost(DataSet: TDataSet);
    procedure MainDatasetCalcFields(DataSet: TDataSet);
    procedure RefreshTimerTimer(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
  private
    FMergeId: string;
    FBatchId: integer;
    FOutstandingImports: integer;
    FAllowMerge: boolean;
    FMergingId: integer;
    FMergingIdStr: string;

    [async]
    procedure MergeErrorDataJob(const ARecordId: string); async;
    [async]
    procedure ShowImportData(const ARecordId: string); async;
    [async]
    procedure ShowMergedData(const ARecordId: string); async;
    [async]
    procedure DownloadErrorFile(const ARecordId: string); async;

    procedure EnableRefreshTimer(const AnInterval: Integer = 1000);
    procedure RefreshControls;

    [async]
    procedure AddNewImport; async;
    [async]
    procedure CheckAllImportsCompleted; async;
    procedure SetImportBatchToCancelling(ARecordId: string);

  protected
    function InitSortCol: Integer; override;
    function InitSortDirection: TSortDirection; override;
    procedure AddRecord(const ARecordId: string); override;
    function CreateGridInFormCreate: boolean; override;

    [async]
    procedure MergeDataJob(const ARecordId: string); async;
    [async]
    procedure CancelImportJob(const ARecordId: string); async;
    procedure ViewData(const ARecordId: string);
    procedure AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement); override;
    procedure PrepareForm; override;
    procedure LoadData; override;
    function GetEditFormClass: TFormClass; override;
  public
    { Public declarations }
    procedure CheckIfCanSubmit;
  protected procedure LoadDFMValues; override; end;

var
  ImportListForm: TImportListForm;

implementation

{$R *.dfm}

uses
  XData.Web.Client,
  //KSS WEBLib.WebCtrls,
  ImportBatch,
  ImportForm,
  MainDataModule,
  ImportData,
  DonorList,
  DonationList, SMX.Web.Service.Consts, SMX.Web.Layout.Utils,MainForm;

procedure TImportListForm.WebFormDestroy(Sender: TObject);
begin
  //Make sure timers off before navigating off the form.
  RefreshTimer.Enabled := False;
  ImportCount.Enabled := False;
  inherited;
end;

procedure TImportListForm.AddButtonClick(Sender: TObject);
begin
  inherited;
end;

{ TImportListForm }

procedure TImportListForm.AddRecord(const ARecordId: string);
begin
  AddNewImport;
end;

procedure TImportListForm.AddRowActions(const ARecordId: string; AParentElement: TJSHTMLElement);

  procedure ViewDataClick(Sender: TObject);
  begin
    ViewData(TLayoutUtils.GetActionRecordId(Sender));
  end;

  procedure MergeDataClick(Sender: TObject);
  begin
    FMergingId := TLayoutUtils.GetActionRecordIdInt(Sender);
    THTMLSpan(Sender).Enabled := False;
    MergeDataJob(TLayoutUtils.GetActionRecordId(Sender));
  end;

  procedure MergeErrorDataClick(Sender: TObject);
  begin
    THTMLSpan(Sender).Enabled := False;
    MergeErrorDataJob(TLayoutUtils.GetActionRecordId(Sender));
  end;

  procedure CancelImportClick(Sender: TObject);
  begin
    CancelImportJob(TLayoutUtils.GetActionRecordId(Sender));
  end;

  procedure DownloadErrorFileClick(Sender: TObject);
  begin
    DownloadErrorFile(TLayoutUtils.GetActionRecordId(Sender));
  end;

var
  Span: THTMLSpan;
  BatchState: string;
  NoOfErrors: integer;
begin
  // (New, Processing, Errors, Valid, Merging, Merged
  BatchState := MainDataset.FieldByName('BatchState').AsString;
  NoOfErrors := MainDataSet.FieldByName('ErrorRecords').AsInteger;

  if (BatchState = 'Valid') or (BatchState = 'Errors') then
  begin
    Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-table', 'View data');
    TLayoutUtils.SetActionRecordId(Span, ARecordId);
    Span.OnClick := @ViewDataClick;

    if (BatchState = 'Errors') then
    begin
      Span := TLayoutUtils.RowActionSpan(AParentElement, 'fa-solid fa-file-csv', 'Download Error File');
      TLayoutUtils.SetActionRecordId(Span, ARecordId);
      Span.OnClick := @DownloadErrorFileClick;
    end;

    if NoOfErrors > 0 then
    begin
      Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-tags', 'Merge data excluding errors');
      TLayoutUtils.SetActionRecordId(Span, ARecordId);

      if ARecordId.ToInteger <> FMergingId then
      begin
        Span.OnClick := @MergeErrorDataClick;
        Span.OnDblClick := nil;
      end;
    end
    else
    begin
      Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-tags', 'Merge data');
      TLayoutUtils.SetActionRecordId(Span, ARecordId);
      if ARecordId.ToInteger <> FMergingId then
      begin
        Span.OnClick := @MergeDataClick;
        Span.OnDblClick := nil;
      end;
    end;

    if (BatchState <> 'Cancelled') then
    begin
      Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-ban', 'Cancel import');
      TLayoutUtils.SetActionRecordId(Span, ARecordId);
      Span.OnClick := @CancelImportClick;
    end;
  end
  else if (BatchState = 'Merged') or (BatchState = 'Merging') then
  begin
    Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-table', 'View data');
    TLayoutUtils.SetActionRecordId(Span, ARecordId);
    Span.OnClick := @ViewDataClick;
  end
  else if ((BatchState = 'Failed') or (BatchState = 'Duplicate')) then
  begin
    Span := TLayoutUtils.RowActionSpan(AParentElement, 'fad fa-ban', 'Cancel import');
    TLayoutUtils.SetActionRecordId(Span, ARecordId);
    Span.OnClick := @CancelImportClick;
  end;
end;

procedure TImportListForm.SetImportBatchToCancelling(ARecordId: string);
begin
  if MainDataset.Locate('Id', ARecordId, []) then
  begin
    MainDataset.Edit;
    MainDataset.FieldByName('BatchState').AsString := 'Cancelling';
    MainDataset.Post;
  end;
end;

procedure TImportListForm.CancelImportJob(const ARecordId: string);
var
  lJobParams: JS.TJSObject;
  lRetval: TXDataClientResponse;
  JobId: Integer;
begin
  SetImportBatchToCancelling(ARecordId);

  if not MainDataset.Locate('Id', ARecordId, []) then
    Exit;

  lJobParams := JS.TJSObject.new;
  lJobParams.Properties['ImportId'] := ARecordId.ToInteger;

  lRetval := await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync(IJOBSVC_SCHEDULEJOB,
    ['TImportCancelJob', 'AnyAdminUser', JS.TJSJSON.stringify(lJobParams), 'Undecided', 'Production']));

  JobId := JS.ToInteger(lRetval.ResultAsObject['value']);

  EnableRefreshTimer(1000);

  ShowAToast('Import Cancellation', Format('The job to cancel your import has been placed. The Job Number is %d',
    [JobId]), 'clock.png');
end;

procedure TImportListForm.EnableRefreshTimer(const AnInterval: Integer);
begin
  if RefreshTimer.Enabled then
    Exit;
  RefreshTimer.Interval := AnInterval;
  RefreshTimer.Enabled := True;
end;

function TImportListForm.GetEditFormClass: TFormClass;
begin
  Result := TImportBatchForm;
end;

function TImportListForm.InitSortCol: Integer;
begin
  Result := 0;
end;

function TImportListForm.InitSortDirection: TSortDirection;
begin
  Result := TSortDirection.sdDesc;
end;

procedure TImportListForm.LoadData;
begin
  CreateGridPlugin;
  FMergeId := '';
end;

procedure TImportListForm.MainDatasetAfterApplyUpdates(Sender: TDataSet; Info: TResolveResults);
begin
  inherited;
  if FMergeId <> '' then
  begin
    MergeDataJob(FMergeId);
    FMergeId := '';
    EnableRefreshTimer;
  end;
end;

procedure TImportListForm.MainDatasetAfterOpen(Dataset: TDataSet);
begin
  inherited;
  MainDataset.EnableControls;
end;

procedure TImportListForm.MergeDataJob(const ARecordId: string);
var
  lJobParams: JS.TJSObject;
  lRetval: TXDataClientResponse;
  JobId: Integer;
begin
  lJobParams := JS.TJSObject.new;
  lJobParams.Properties['ImportId'] := ARecordId.ToInteger;

  lRetval := await(TXDataClientResponse, MainData.WebClient.RawInvokeAsync(IJOBSVC_SCHEDULEJOB,
    ['TImportMergeJob', 'AnyAdminUser', JS.TJSJSON.stringify(lJobParams), 'Undecided', 'Production']));

  JobId := JS.ToInteger(lRetval.ResultAsObject['value']);

  EnableRefreshTimer(1000);

  ShowAToast('Data Merge', Format('The job to merge your import data has been placed. The Job Number is %d', [JobId]),
    'clock.png');
  ImportCount.Enabled := True;
end;

procedure TImportListForm.MergeErrorDataJob(const ARecordId: string);
var
  mr: TModalResult;
begin
  mr := await(TModalResult, ImportDialog.ShowDialog('Do you want to ignore the errors and import?',
    WEBLib.Dialogs.mtConfirmation, [mbYes, mbNo]));
  if mr = mrYes then
  begin
    if MainDataset.Locate('Id', ARecordId, []) then
    begin
      FMergeId := ARecordId;
      FMergingId := ARecordId.ToInteger;
      MergeDataJob(ARecordId);
    end;
  end;
end;

procedure TImportListForm.PrepareForm;
begin
  FIdField := 'Id';
end;

procedure TImportListForm.RefreshControls;
var
  FilterStr: string;
begin
  //FGridPlugin.Load;
  FilterStr := 'SourceType eq ''Import''';
  FGridPlugin.SetPreparedFilter(FilterStr);
end;


procedure TImportListForm.RefreshTimerTimer(Sender: TObject);
begin
  RefreshControls;
  RefreshTimer.Enabled := False;
end;

procedure TImportListForm.ShowImportData(const ARecordId: string);
var
  AForm: TImportDataList;
begin
  ImportCount.Enabled := False;

  AForm := TImportDataList.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    AForm.ElementClassName := 'PopUpForm';
    await(TForm, AForm.Load());
    AForm.ImportId := ARecordId.ToInteger;
    AForm.AfterCreated;
    await(TModalResult, AForm.Execute);
  finally
    AForm.Free;
    AForm := nil;
    ImportCount.Enabled := true;
    EnableRefreshTimer(1000);
  end;
end;

procedure TImportListForm.ShowMergedData(const ARecordId: string);
var
  AForm: TDonations_List;
begin
  ImportCount.Enabled := False;
  AForm := TDonations_List.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    AForm.ElementClassName := 'PopUpForm';

    await(TForm, AForm.Load());
    AForm.ImportId := ARecordId.ToInteger;
    AForm.AfterCreated;
    await(TModalResult, AForm.Execute);
  finally
    AForm.Free;
    AForm := nil;
    ImportCount.Enabled := True;
  end;
end;

procedure TImportListForm.ViewData(const ARecordId: string);
var
  BatchState: string;
begin
  if MainDataset.Locate('Id', ARecordId, []) then
  begin
    BatchState := MainDataset.FieldByName('BatchState').AsString;
    if BatchState = 'Merged' then
      ShowMergedData(ARecordId)
    else if (BatchState = 'Valid') or (BatchState = 'Errors') then
      ShowImportData(ARecordId)
    else
      ShowMessage('This data isn''t available for viewing at the moment');
  end;
end;

procedure TImportListForm.WebFormShow(Sender: TObject);
begin
  inherited;
  LoadData;
  RefreshControls;
  ImportCount.Enabled := True;
end;

procedure TImportListForm.AddNewImport;
var
  AForm: TImportPage;

begin
  AForm := TImportPage.Create(Self);
  try
    AForm.Popup := True;
    AForm.PopupOpacity := 1;
    AForm.ElementClassName := 'PopUpForm';
    await(TForm, AForm.Load());

    AForm.ImportBatches := MainDataset;
    AForm.AfterCreated;
    await(TModalResult, AForm.Execute);
  finally
    AForm.Free;
    AForm := nil;
    EnableRefreshTimer(1000);
    ImportCount.Enabled := true;
  end;
end;

function TImportListForm.CreateGridInFormCreate: boolean;
begin
  result := false;
end;

procedure TImportListForm.CheckAllImportsCompleted;
var
  lRetval: TXDataClientResponse;
begin
  lRetval := await(TXDataClientResponse,
    MainData.WebClient.RawInvokeAsync('IGiftAiderUtilsService.ImportsOutstanding', []));
  FOutstandingImports := JS.ToInteger(lRetval.ResultAsObject['value']);
end;

procedure TImportListForm.DataTableGetCellChildren(Sender: TObject; ACol, ARow:
    Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
begin
  inherited;

  if ((ACol = 4) and (ARow <> 0)) and
     ((DataTable.Cells[4, ARow] = 'New') or (DataTable.Cells[4, ARow] = 'Processing')) then
    DataTable.Cells[4, ARow] := 'Importing ...';
end;

procedure TImportListForm.ImportCountTimer(Sender: TObject);
begin
  RefreshControls;
  ImportCount.Interval := 10000;
  CheckIfCanSubmit;
end;

procedure TImportListForm.MainDatasetCalcFields(DataSet: TDataSet);
var
  lText: string;
  lTotal, lGiftAid: double;
begin
  inherited;

  lText := MainDatasetSourceType.Value;
  if lText = 'Import' then
     MainDatasetSourceDescription.Value := 'File Import'
  else if lText = 'GAImport' then
     MainDatasetSourceDescription.Value := 'GA Desktop'
  else if lText = 'Manual' then
     MainDatasetSourceDescription.Value := 'Manual Data Entry'
  else
     MainDatasetSourceDescription.Value := lText;

  if MainDatasetAmountTotal.Value = 0.00 then
  begin
    MainDatasetGiftAidTotalStr.Value := '';
    MainDatasetAmountTotalStr.Value := '';
  end
  else
  begin
    MainDatasetGiftAidTotalStr.Value := Format('%0.2f', [MainDatasetGiftAidTotal.Value]);
    MainDatasetAmountTotalStr.Value := Format('%0.2f', [MainDatasetAmountTotal.Value]);
  end;
end;

procedure TImportListForm.MainDatasetAfterPost(DataSet: TDataSet);
begin
  inherited;
  EnableRefreshTimer(1000);
end;

procedure TImportListForm.DownloadErrorFile(const ARecordId: string);
var
  lFileName, lFile: string;
  lRetval: TXDataClientResponse;
  lResult: JS.TJSObject;
  JSONFileData: string;
  lErrorFileName: string;
  lErrorFileData: string;
  ErrorFile: TStringList;
  lSourceFile: string;
  lPos: integer;
begin
  if MainDataset.Locate('Id', ARecordId, []) then
  begin
    lSourceFile := MainDataset.FieldByName('SourceFile').AsString;

    lSourceFile := StringReplace(lSourceFile, '.xlsx', '.csv', []);
    lSourceFile := StringReplace(lSourceFile, '.xls', '.csv', []);

    lErrorFileName := lSourceFile;
    lPos := Pos('.csv', lErrorFileName);
    lErrorFileName.Insert(lPos-1, '_ImportErrors');

    lRetval := await(TXDataClientResponse,
      MainData.WebClient.RawInvokeAsync('IGiftAiderService.GetErrorFile',
      [lErrorFileName]));

    lErrorFileData  := JS.ToString(lRetval.ResultAsObject['value']);

    Application.DownloadTextFile(lErrorFileData, lErrorFileName);
  end;
end;

procedure TImportListForm.CheckIfCanSubmit;
begin
  //This should always true but just in case...
  if assigned(MainPage) then
    MainPage.CheckCanSubmit
end;

procedure TImportListForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  ImportDialog := TMessageDlg.Create(Self);
  CloseThisButton := TButton.Create('CloseThisButton');
  TableBottom := THTMLDiv.Create('TableBottom');
  TableTop := THTMLDiv.Create('TableTop');
  navigator := THTMLDiv.Create('navigator');
  navcol4 := THTMLDiv.Create('navcol-4');
  MainDatasetId := TIntegerField.Create(Self);
  MainDatasetDateAdded := TDateTimeField.Create(Self);
  MainDatasetAddedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdatedBy := TIntegerField.Create(Self);
  MainDatasetLastUpdated := TDateTimeField.Create(Self);
  MainDatasetBatchResolution := TStringField.Create(Self);
  MainDatasetBatchState := TStringField.Create(Self);
  MainDatasetRecordsImported := TIntegerField.Create(Self);
  MainDatasetValidRecords := TIntegerField.Create(Self);
  MainDatasetErrorRecords := TIntegerField.Create(Self);
  MainDatasetMatched := TIntegerField.Create(Self);
  MainDatasetMerged := TIntegerField.Create(Self);
  MainDatasetSourceType := TStringField.Create(Self);
  MainDatasetSourceDescription := TStringField.Create(Self);
  MainDatasetSourceFile := TStringField.Create(Self);
  MainDatasetGiftAidTotal := TFloatField.Create(Self);
  MainDatasetAmountTotal := TFloatField.Create(Self);
  MainDatasetGiftAidTotalStr := TStringField.Create(Self);
  MainDatasetAmountTotalStr := TStringField.Create(Self);
  RefreshTimer := TTimer.Create(Self);
  ImportCount := TTimer.Create(Self);

  DataTable.BeforeLoadDFMValues;
  ImportDialog.BeforeLoadDFMValues;
  CloseThisButton.BeforeLoadDFMValues;
  TableBottom.BeforeLoadDFMValues;
  TableTop.BeforeLoadDFMValues;
  navigator.BeforeLoadDFMValues;
  navcol4.BeforeLoadDFMValues;
  MainDataset.BeforeLoadDFMValues;
  MainDatasetId.BeforeLoadDFMValues;
  MainDatasetDateAdded.BeforeLoadDFMValues;
  MainDatasetAddedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdatedBy.BeforeLoadDFMValues;
  MainDatasetLastUpdated.BeforeLoadDFMValues;
  MainDatasetBatchResolution.BeforeLoadDFMValues;
  MainDatasetBatchState.BeforeLoadDFMValues;
  MainDatasetRecordsImported.BeforeLoadDFMValues;
  MainDatasetValidRecords.BeforeLoadDFMValues;
  MainDatasetErrorRecords.BeforeLoadDFMValues;
  MainDatasetMatched.BeforeLoadDFMValues;
  MainDatasetMerged.BeforeLoadDFMValues;
  MainDatasetSourceType.BeforeLoadDFMValues;
  MainDatasetSourceDescription.BeforeLoadDFMValues;
  MainDatasetSourceFile.BeforeLoadDFMValues;
  MainDatasetGiftAidTotal.BeforeLoadDFMValues;
  MainDatasetAmountTotal.BeforeLoadDFMValues;
  MainDatasetGiftAidTotalStr.BeforeLoadDFMValues;
  MainDatasetAmountTotalStr.BeforeLoadDFMValues;
  MainDataSource.BeforeLoadDFMValues;
  ListCloseTimer.BeforeLoadDFMValues;
  RefreshTimer.BeforeLoadDFMValues;
  ImportCount.BeforeLoadDFMValues;
  try
    SetEvent(Self, 'OnShow', 'WebFormShow');
    DataTable.Top := 110;
    DataTable.Columns.Clear;
    with DataTable.Columns.Add do
    begin
      DataField := 'DateAdded';
      Title := 'Date';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'SourceDescription';
      Title := 'Source';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'RecordsImported';
      Title := 'Imported';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'ErrorRecords';
      Title := 'Errors';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'Merged';
      Title := 'Merged';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'GiftAidTotalStr';
      Title := 'Gift Aid';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'AmountTotalStr';
      Title := 'Amount';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'BatchState';
      Title := 'State';
    end;
    with DataTable.Columns.Add do
    begin
      DataField := 'SourceFile';
      Title := 'Source File';
    end;
    with DataTable.Columns.Add do
    begin
      Title := 'Actions';
    end;
    ImportDialog.SetParentComponent(Self);
    ImportDialog.Name := 'ImportDialog';
    ImportDialog.Left := 584;
    ImportDialog.Top := 136;
    ImportDialog.Width := 24;
    ImportDialog.Height := 24;
    ImportDialog.HeightStyle := ssAuto;
    ImportDialog.WidthStyle := ssAuto;
    ImportDialog.Buttons := [];
    ImportDialog.Opacity := 0.200000000000000000;
    ImportDialog.ElementButtonClassName := 'btn';
    ImportDialog.ElementDialogClassName := 'shadow-lg p-3 mb-5 bg-white rounded';
    ImportDialog.ElementTitleClassName := 'text-body';
    ImportDialog.ElementContentClassName := 'text-body';
    CloseThisButton.SetParentComponent(Self);
    CloseThisButton.Name := 'CloseThisButton';
    CloseThisButton.Left := 0;
    CloseThisButton.Top := 0;
    CloseThisButton.Width := 96;
    CloseThisButton.Height := 25;
    CloseThisButton.Caption := 'CloseThisButton';
    CloseThisButton.ChildOrder := 10;
    CloseThisButton.ElementFont := efCSS;
    CloseThisButton.ElementPosition := epIgnore;
    CloseThisButton.HeightStyle := ssAuto;
    CloseThisButton.HeightPercent := 100.000000000000000000;
    CloseThisButton.WidthStyle := ssAuto;
    CloseThisButton.WidthPercent := 100.000000000000000000;
    TableBottom.SetParentComponent(Self);
    TableBottom.Name := 'TableBottom';
    TableBottom.Left := 101;
    TableBottom.Top := 0;
    TableBottom.Width := 96;
    TableBottom.Height := 25;
    TableBottom.HeightStyle := ssAuto;
    TableBottom.WidthStyle := ssAuto;
    TableBottom.ChildOrder := 11;
    TableBottom.ElementPosition := epIgnore;
    TableBottom.ElementFont := efCSS;
    TableBottom.Role := '';
    TableTop.SetParentComponent(Self);
    TableTop.Name := 'TableTop';
    TableTop.Left := 505;
    TableTop.Top := 0;
    TableTop.Width := 96;
    TableTop.Height := 25;
    TableTop.HeightStyle := ssAuto;
    TableTop.WidthStyle := ssAuto;
    TableTop.ChildOrder := 12;
    TableTop.ElementPosition := epIgnore;
    TableTop.ElementFont := efCSS;
    TableTop.Role := '';
    navigator.SetParentComponent(Self);
    navigator.Name := 'navigator';
    navigator.Left := 0;
    navigator.Top := 30;
    navigator.Width := 96;
    navigator.Height := 25;
    navigator.HeightStyle := ssAuto;
    navigator.WidthStyle := ssAuto;
    navigator.ChildOrder := 13;
    navigator.ElementPosition := epIgnore;
    navigator.ElementFont := efCSS;
    navigator.Role := '';
    navcol4.SetParentComponent(Self);
    navcol4.Name := 'navcol4';
    navcol4.Left := 101;
    navcol4.Top := 30;
    navcol4.Width := 96;
    navcol4.Height := 25;
    navcol4.HeightStyle := ssAuto;
    navcol4.WidthStyle := ssAuto;
    navcol4.ChildOrder := 14;
    navcol4.ElementPosition := epIgnore;
    navcol4.ElementFont := efCSS;
    navcol4.Role := '';
    MainDataset.AfterApplyUpdates := MainDatasetAfterApplyUpdates;
    SetEvent(MainDataset, Self, 'OnCalcFields', 'MainDatasetCalcFields');
    MainDataset.EntitySetName := 'ImportBatch';
    MainDatasetId.SetParentComponent(MainDataset);
    MainDatasetId.Name := 'MainDatasetId';
    MainDatasetId.FieldName := 'Id';
    MainDatasetDateAdded.SetParentComponent(MainDataset);
    MainDatasetDateAdded.Name := 'MainDatasetDateAdded';
    MainDatasetDateAdded.FieldName := 'DateAdded';
    MainDatasetAddedBy.SetParentComponent(MainDataset);
    MainDatasetAddedBy.Name := 'MainDatasetAddedBy';
    MainDatasetAddedBy.FieldName := 'AddedBy';
    MainDatasetLastUpdatedBy.SetParentComponent(MainDataset);
    MainDatasetLastUpdatedBy.Name := 'MainDatasetLastUpdatedBy';
    MainDatasetLastUpdatedBy.FieldName := 'LastUpdatedBy';
    MainDatasetLastUpdated.SetParentComponent(MainDataset);
    MainDatasetLastUpdated.Name := 'MainDatasetLastUpdated';
    MainDatasetLastUpdated.FieldName := 'LastUpdated';
    MainDatasetBatchResolution.SetParentComponent(MainDataset);
    MainDatasetBatchResolution.Name := 'MainDatasetBatchResolution';
    MainDatasetBatchResolution.FieldName := 'BatchResolution';
    MainDatasetBatchResolution.Size := 6;
    MainDatasetBatchState.SetParentComponent(MainDataset);
    MainDatasetBatchState.Name := 'MainDatasetBatchState';
    MainDatasetBatchState.FieldName := 'BatchState';
    MainDatasetBatchState.Size := 10;
    MainDatasetRecordsImported.SetParentComponent(MainDataset);
    MainDatasetRecordsImported.Name := 'MainDatasetRecordsImported';
    MainDatasetRecordsImported.FieldName := 'RecordsImported';
    MainDatasetValidRecords.SetParentComponent(MainDataset);
    MainDatasetValidRecords.Name := 'MainDatasetValidRecords';
    MainDatasetValidRecords.FieldName := 'ValidRecords';
    MainDatasetErrorRecords.SetParentComponent(MainDataset);
    MainDatasetErrorRecords.Name := 'MainDatasetErrorRecords';
    MainDatasetErrorRecords.FieldName := 'ErrorRecords';
    MainDatasetMatched.SetParentComponent(MainDataset);
    MainDatasetMatched.Name := 'MainDatasetMatched';
    MainDatasetMatched.FieldName := 'Matched';
    MainDatasetMerged.SetParentComponent(MainDataset);
    MainDatasetMerged.Name := 'MainDatasetMerged';
    MainDatasetMerged.FieldName := 'Merged';
    MainDatasetSourceType.SetParentComponent(MainDataset);
    MainDatasetSourceType.Name := 'MainDatasetSourceType';
    MainDatasetSourceType.FieldName := 'SourceType';
    MainDatasetSourceType.Size := 9;
    MainDatasetSourceDescription.SetParentComponent(MainDataset);
    MainDatasetSourceDescription.Name := 'MainDatasetSourceDescription';
    MainDatasetSourceDescription.FieldKind := fkCalculated;
    MainDatasetSourceDescription.FieldName := 'SourceDescription';
    MainDatasetSourceDescription.Size := 25;
    MainDatasetSourceDescription.Calculated := True;
    MainDatasetSourceFile.SetParentComponent(MainDataset);
    MainDatasetSourceFile.Name := 'MainDatasetSourceFile';
    MainDatasetSourceFile.FieldName := 'SourceFile';
    MainDatasetSourceFile.Size := 75;
    MainDatasetGiftAidTotal.SetParentComponent(MainDataset);
    MainDatasetGiftAidTotal.Name := 'MainDatasetGiftAidTotal';
    MainDatasetGiftAidTotal.FieldName := 'GiftAidTotal';
    MainDatasetGiftAidTotal.currency := True;
    MainDatasetAmountTotal.SetParentComponent(MainDataset);
    MainDatasetAmountTotal.Name := 'MainDatasetAmountTotal';
    MainDatasetAmountTotal.FieldName := 'AmountTotal';
    MainDatasetAmountTotal.currency := True;
    MainDatasetGiftAidTotalStr.SetParentComponent(MainDataset);
    MainDatasetGiftAidTotalStr.Name := 'MainDatasetGiftAidTotalStr';
    MainDatasetGiftAidTotalStr.FieldKind := fkCalculated;
    MainDatasetGiftAidTotalStr.FieldName := 'GiftAidTotalStr';
    MainDatasetGiftAidTotalStr.Size := 11;
    MainDatasetGiftAidTotalStr.Calculated := True;
    MainDatasetAmountTotalStr.SetParentComponent(MainDataset);
    MainDatasetAmountTotalStr.Name := 'MainDatasetAmountTotalStr';
    MainDatasetAmountTotalStr.FieldKind := fkCalculated;
    MainDatasetAmountTotalStr.FieldName := 'AmountTotalStr';
    MainDatasetAmountTotalStr.Size := 11;
    MainDatasetAmountTotalStr.Calculated := True;
    MainDataSource.Left := 168;
    ListCloseTimer.Interval := 10000;
    RefreshTimer.SetParentComponent(Self);
    RefreshTimer.Name := 'RefreshTimer';
    RefreshTimer.Enabled := False;
    SetEvent(RefreshTimer, Self, 'OnTimer', 'RefreshTimerTimer');
    RefreshTimer.Left := 560;
    RefreshTimer.Top := 16;
    ImportCount.SetParentComponent(Self);
    ImportCount.Name := 'ImportCount';
    SetEvent(ImportCount, Self, 'OnTimer', 'ImportCountTimer');
    ImportCount.Left := 96;
    ImportCount.Top := 424;
  finally
    DataTable.AfterLoadDFMValues;
    ImportDialog.AfterLoadDFMValues;
    CloseThisButton.AfterLoadDFMValues;
    TableBottom.AfterLoadDFMValues;
    TableTop.AfterLoadDFMValues;
    navigator.AfterLoadDFMValues;
    navcol4.AfterLoadDFMValues;
    MainDataset.AfterLoadDFMValues;
    MainDatasetId.AfterLoadDFMValues;
    MainDatasetDateAdded.AfterLoadDFMValues;
    MainDatasetAddedBy.AfterLoadDFMValues;
    MainDatasetLastUpdatedBy.AfterLoadDFMValues;
    MainDatasetLastUpdated.AfterLoadDFMValues;
    MainDatasetBatchResolution.AfterLoadDFMValues;
    MainDatasetBatchState.AfterLoadDFMValues;
    MainDatasetRecordsImported.AfterLoadDFMValues;
    MainDatasetValidRecords.AfterLoadDFMValues;
    MainDatasetErrorRecords.AfterLoadDFMValues;
    MainDatasetMatched.AfterLoadDFMValues;
    MainDatasetMerged.AfterLoadDFMValues;
    MainDatasetSourceType.AfterLoadDFMValues;
    MainDatasetSourceDescription.AfterLoadDFMValues;
    MainDatasetSourceFile.AfterLoadDFMValues;
    MainDatasetGiftAidTotal.AfterLoadDFMValues;
    MainDatasetAmountTotal.AfterLoadDFMValues;
    MainDatasetGiftAidTotalStr.AfterLoadDFMValues;
    MainDatasetAmountTotalStr.AfterLoadDFMValues;
    MainDataSource.AfterLoadDFMValues;
    ListCloseTimer.AfterLoadDFMValues;
    RefreshTimer.AfterLoadDFMValues;
    ImportCount.AfterLoadDFMValues;
  end;
end;

end.
